import { render, staticRenderFns } from "./ConsumosWrapper.vue?vue&type=template&id=a4466ed6&scoped=true"
import script from "./ConsumosWrapper.vue?vue&type=script&lang=js"
export * from "./ConsumosWrapper.vue?vue&type=script&lang=js"
import style0 from "./ConsumosWrapper.vue?vue&type=style&index=0&id=a4466ed6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4466ed6",
  null
  
)

export default component.exports